import { render, staticRenderFns } from "./ServiceSequenceList.vue?vue&type=template&id=38c89597&scoped=true"
import script from "./ServiceSequenceList.vue?vue&type=script&lang=js"
export * from "./ServiceSequenceList.vue?vue&type=script&lang=js"
import style0 from "./ServiceSequenceList.vue?vue&type=style&index=0&id=38c89597&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c89597",
  null
  
)

export default component.exports